var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.769,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "disabled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2518",
    d: "M8.306 0a2.8 2.8 0 00-2.777 2.787 2.764 2.764 0 002.162 2.672v7.457a.615.615 0 00.615.615h7.63l3.517 6.448a.615.615 0 00.538.327l2.153-.01a.615.615 0 00.54-.3.615.615 0 000-.62.615.615 0 00-.54-.3l-1.787.01-3.517-6.448a.615.615 0 00-.538-.327h-7.38V9.543h6.15a.615.615 0 00.54-.305.615.615 0 000-.62.615.615 0 00-.54-.305h-6.15V5.478a2.75 2.75 0 002.143-2.681A2.785 2.785 0 008.306 0zm-.154 1.24a1.508 1.508 0 01.154 0 1.545 1.545 0 011.547 1.547 1.52 1.52 0 01-1.547 1.52 1.512 1.512 0 01-1.537-1.52A1.548 1.548 0 018.153 1.24zM4.28 8.986a.615.615 0 00-.279.087 8.017 8.017 0 00-3.728 4.862 8.009 8.009 0 005.66 9.793 8.009 8.009 0 009.793-5.661.617.617 0 00-.161-.6.617.617 0 00-.6-.159.617.617 0 00-.435.437 6.755 6.755 0 01-8.28 4.791 6.755 6.755 0 01-4.786-8.284 6.775 6.775 0 013.152-4.113.615.615 0 00.309-.619.615.615 0 00-.463-.515.615.615 0 00-.183-.019z",
    fill: "#5627d9",
    stroke: "#5627d9",
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "disabled_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2517",
    d: "M0 1532.48h2359.712V0H0z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9771"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 902",
    clipPath: "url(#disabled_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 901",
    transform: "translate(-1482.553 -454.407)",
    clipPath: "url(#disabled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2516",
    d: "M1477.428 449.281h33.02v34.251h-33.02z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 15
  }))))));
}
export default SvgDisabled;


//////////////////
// WEBPACK FOOTER
// ./src/icons/disabled.svg
// module id = 461
// module chunks = 11